import { render, staticRenderFns } from "./promo-modal.vue?vue&type=template&id=ff6be588&"
import script from "./promo-modal.vue?vue&type=script&lang=js&"
export * from "./promo-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports